import React from "react";
import PropTypes from "prop-types";
import "./ktemplevideo.css";

const TempleVideo = () => (
  <div className="video-responsive">
    <video width="560" height="315" autoPlay muted controls>
      <source src="/images/rathyatra.mp4" type="video/mp4" />
      Your browser does not support the video tag.
    </video>
  </div>
);

TempleVideo.propTypes = {
  embedId: PropTypes.string.isRequired
};

export default TempleVideo;